import { config } from "JS/Config";
import { S3Helper } from "JS/Helpers";
import { BaseService } from "../BaseService";

export class PaymentEligibleUsersService extends BaseService {
    async getPaymentEligibleUsers(): Promise<string[]> {
        const s3Sdk = new S3Helper().sdk;
        return new Promise((res, rej) => {
            const params = {
                Bucket: config.s3.paymentEligibleUsers.bucketName,
                Key: config.s3.paymentEligibleUsers.key,
                ResponseCacheControl: "no-cache",
            };
            s3Sdk.getObject(params, (err, data) => {
                err ? rej(err) : res(JSON.parse(data?.Body?.toString()));
            });
        });
    }
}
